import Vue, { VueConstructor } from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import NotFound from "./views/NotFound.vue";
import JobDetail from "./views/JobDetail.vue";
import ExamDetail from "./views/ExamDetail.vue";
import ByPostcode from "./views/ByPostcode.vue";
import TodaysJobs from "./views/TodaysJobs.vue";
import WeeksJobs from "./views/WeeksJobs.vue";
import OverdueJobs from "./views/OverdueJobs.vue";
import JobHistory from "./views/JobHistory.vue";
import RequiredParts from "./views/RequiredParts.vue";
import Checklist from "./views/Checklist.vue";
import ContactLoadFailed from "./views/ContactLoadFailed.vue";
import Auth from "./auth/auth";
import { AuthMode } from "./auth/types";
import Callback from "./views/Callback.vue";
import store from "@/store/store";

Vue.use(Router);

export interface RouteItem {
  path: string;
  name: string;
  component: VueConstructor<Vue>;
  beforeEnter?: (to: any, from: any, next: any) => void;
  props?: any;
  showOnNav?: boolean;
  friendlyName?: string;
}

export const routeItems: RouteItem[] = [
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    beforeEnter: Auth.RouterAuthCheck
  },
  {
    path: "/",
    name: "home",
    component: Home,
    beforeEnter: Auth.RouterAuthCheck
  },
  {
    path: "/Job/:id",
    name: "Job",
    component: JobDetail,
    beforeEnter: Auth.RouterAuthCheck
  },
  {
    path: "/Job/:id/ExamDetail",
    name: "ExamDetail",
    component: ExamDetail,
    beforeEnter: Auth.RouterAuthCheck
  },
  {
    path: "/Job/:id/ExamDetail/Parts",
    name: "RequriedParts",
    component: RequiredParts,
    beforeEnter: Auth.RouterAuthCheck
  },
  {
    path: "/OverdueJobs",
    name: "OverdueJobs",
    component: OverdueJobs,
    beforeEnter: Auth.RouterAuthCheck,
    showOnNav: true,
    friendlyName: "Overdue Jobs"
  },
  {
    path: "/Today",
    name: "Today",
    component: TodaysJobs,
    beforeEnter: Auth.RouterAuthCheck,
    showOnNav: true,
    friendlyName: "Today's Jobs"
  },
  {
    path: "/ThisWeek",
    name: "ThisWeek",
    component: WeeksJobs,
    beforeEnter: Auth.RouterAuthCheck,
    showOnNav: true,
    friendlyName: "This Week's Jobs"
  },
  {
    path: "/ByPostcode/:postcode?",
    name: "ByPostcode",
    component: ByPostcode,
    beforeEnter: Auth.RouterAuthCheck,
    showOnNav: true,
    friendlyName: "By Postcode"
  },
  {
    path: "/History",
    name: "History",
    component: JobHistory,
    beforeEnter: Auth.RouterAuthCheck,
    showOnNav: true,
    friendlyName: "History"
  },
  {
    path: "/identity/callback",
    name: "identityCallback",
    component: Callback,
    props: { mode: AuthMode.Callback }
  },
  {
    path: "/Job/:id/Checklist",
    name: "Checklist",
    component: Checklist,
    beforeEnter: Auth.RouterAuthCheck
  },
  {
    path: "/ContactLoadFailed",
    name: "ContactLoadFailed",
    component: ContactLoadFailed,
    beforeEnter: (to, from, next) => {
      Auth.RouterAuthCheck(to, from, next);
      if (!store.state.Job.JobDetail) {
        next("/");
      }
    }
  }
];

export default new Router({
  mode: "history",
  routes: routeItems
});
